import { Paragraph } from '@zillow/constellation-10';
import React, { useContext } from 'react';
import { useNextStepDataQuery } from '../../../../types/GraphqlTypes';
import StringConstants from '../../../../constants/StringConstants';
import { InboxPageContext } from '../../../../contexts/InboxPageContextProvider';
import InboxSidebarSection from '../InboxSidebarSection';
import InviteToApply from '../InviteToApply';
import { useAuth } from '@zg-rentals/auth-comet';

export default function NextStep(): JSX.Element | null {
  const { conversationId, listingAlias } = useContext(InboxPageContext);
  const { user } = useAuth();
  const { data: nextStepData } = useNextStepDataQuery({
    variables: {
      conversationId: conversationId!,
      listingAlias: listingAlias!,
    },
    fetchPolicy: 'cache-only',
  });

  if (!nextStepData) {
    return null;
  }

  const { inquiry, isApplicationsAllowed, referenceEmail } = nextStepData.ZRM_getConversationById;

  if (inquiry?.isPhoneLead) {
    return (
      <InboxSidebarSection title="Next step">
        <Paragraph>{StringConstants.TOOLTIP.PHONE_LEAD}</Paragraph>
      </InboxSidebarSection>
    );
  }

  if (isApplicationsAllowed && !user?.isMultifamilyCustomer && referenceEmail) {
    return <InviteToApply />;
  }

  return null;
}
